import React, { LegacyRef } from 'react';
import { CardItem } from '../../../components/react/Cards/types';
import { AdventureCard, OfferCard, StayCard } from '../../../components/react/Cards';

const CardsListing = ({
  items,
  cardVariantLower,
  lastElementRef,
  viewDetailsLabel,
  bookingLabel,
  showDescription,
  callToBookLabel
}: {
  items: CardItem[];
  cardVariantLower: string;
  lastElementRef: LegacyRef<HTMLLIElement>;
  viewDetailsLabel: string;
  bookingLabel: string;
  showDescription?: boolean;
  callToBookLabel?: string;
}) => {
  // TODO: add animation to cards when they are loaded (react transition group? or css animation?)

  return (
    <ul
      className={`cards-grid ${cardVariantLower === 'event' ? 'cards-grid--two' : cardVariantLower === 'stay' ? 'cards-grid--stay' : 'cards-grid--three'}`}
    >
      {items &&
        items.map((card, index: number) => {
          if (cardVariantLower === 'adventure' || cardVariantLower === 'event') {
            return (
              <li key={index} ref={index === items.length - 1 ? lastElementRef : null}>
                <AdventureCard
                  card={card}
                  viewDetailsLabel={viewDetailsLabel}
                  bookingLabel={bookingLabel}
                  showDescription={showDescription}
                  callToBookLabel={callToBookLabel}
                />
              </li>
            );
          }

          if (cardVariantLower === 'stay') {
            return (
              <li
                key={index}
                className={`${index > 2 ? 'cards-grid__stay-item--large' : 'cards-grid__stay-item'}`}
                ref={index === items.length - 1 ? lastElementRef : null}
              >
                <StayCard
                  card={card}
                  viewDetailsLabel={viewDetailsLabel}
                  bookingLabel={bookingLabel}
                  showDescription={showDescription}
                  callToBookLabel={callToBookLabel}
                />
              </li>
            );
          }

          if (cardVariantLower === 'offer') {
            return (
              <li key={index} ref={index === items.length - 1 ? lastElementRef : null}>
                <OfferCard
                  card={card}
                  viewDetailsLabel={viewDetailsLabel}
                  bookingLabel={bookingLabel}
                  showDescription={showDescription}
                  callToBookLabel={callToBookLabel}
                />
              </li>
            );
          }

          return null;
        })}
    </ul>
  );
};

export default CardsListing;
